import React, { Suspense, useEffect, useState } from "react";
import { Analytics } from "@vercel/analytics/react";
import { SpeedInsights } from "@vercel/speed-insights/react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ProtectedRoute from "./components/ProtectedRoute"
import MembersLayout from "./components/MembersLayout"

import Home from "./pages/Home";
import About from "./pages/About";
import Contact from "./pages/Contact";
import Header from "./components/Header";
import Footer from "./components/Footer";
import LabelFooter from "./components/LabelFooter";
import PrivacyStatement from "./pages/PrivacyStatement";
import MembershipTerms from "./pages/MembershipTerms";
import ProductPage from "./pages/Product";
import ProductOverview from "./pages/ProductOverview";
import RequestAccess from "./pages/RequestAccess";
import EventOverview from "./pages/EventOverview";
import HowItWorks from "./pages/HowItWorks";
import Wallet from "./pages/Wallet";
import WearableStories from "./pages/discover/WearableStories";
import Bookings from "./pages/Bookings";
import LaunchEvent from "./pages/LaunchEvent";
import Create_LabyrinthScarf from "./pages/create/LabyrinthScarf";
import Create_KnitPlus from "./pages/create/KnitPlus"
import Create_HopeBlanket from "./pages/create/HopeBlanket"
import ReadData from "./pages/ReadData"
import MembersHome from "./pages/MembersHome"
import AuthCallback from "./pages/AuthCallback"
import SignIn from "./pages/SignIn"
import ProfileSettings from "./pages/ProfileSettings";
import Store from "./pages/Store"
import ReadStory from "./pages/ReadStory";
import ProductGift from "./pages/ProductGiftPage";
import Drops from "./pages/Drops";
import JournalStory from "./pages/JournalStory"
import FashionPage from "./pages/discover/FashionPage";
import PalaisAntoia from "./pages/PalaisAntoia.jsx";

const TrionfiOverview = React.lazy(() => import("./pages/TrionfiOverview.jsx"));
const TrionfiCardPage = React.lazy(() => import("./pages/TrionfiCardPage.jsx"));



function AppLayout() {
  const [, setMenuOpen] = useState(false);
  const [snipcartOpen, setSnipcartOpen] = useState(false);
  const location = useLocation();

  const isCartRoute =
  window.location.hash.startsWith("#/cart") ||
  window.location.hash.startsWith("#/checkout");
  const hideChrome = snipcartOpen || isCartRoute;

  /* !! Hide header */
/* const isMemberSpace =
  location.pathname.startsWith("/members") ||
  location.pathname.startsWith("/wallet") ||
  location.pathname === "/settings"; */

const isTrionfiRoute =
  location.pathname === "/palaisantoia/trionfi" ||
  location.pathname.startsWith("/palaisantoia/trionfi/");

const hideHeader =
  ["/signin", "/palaisantoia"].includes(location.pathname) ||
/*   isMemberSpace || */
  isTrionfiRoute;

  useEffect(() => {
    let unsubscribeRoute = null;
    let unsubscribeInit = null;
    let cancelled = false;

    const bind = () => {
      if (!window.Snipcart?.events?.on) return false;

      // When Snipcart initializes, bind routechanged (cart opened/closed)
      unsubscribeInit = window.Snipcart.events.on("snipcart.initialized", () => {
        unsubscribeRoute?.();

        unsubscribeRoute = window.Snipcart.events.on("theme.routechanged", ({ from, to }) => {
          // Docs pattern: "/" -> something = opened, something -> "/" = closed
          if (from === "/" && to !== "/") setSnipcartOpen(true);
          if (from !== "/" && to === "/") setSnipcartOpen(false);
        });
      });

      return true;
    };

    // Try now, otherwise keep trying for a bit (script loads async)
    if (!bind()) {
      const iv = setInterval(() => {
        if (cancelled) return clearInterval(iv);
        if (bind()) clearInterval(iv);
      }, 200);

      return () => {
        cancelled = true;
        clearInterval(iv);
        unsubscribeRoute?.();
        unsubscribeInit?.();
      };
    }

    return () => {
      cancelled = true;
      unsubscribeRoute?.();
      unsubscribeInit?.();
    };
  }, []);

  // Optional: prevent page scroll behind cart
  useEffect(() => {
    document.body.style.overflow = snipcartOpen ? "hidden" : "";
    return () => (document.body.style.overflow = "");
  }, [snipcartOpen]);


  /* !! Hide footer */
  const hideFooterOn = ["/signin", "/create/hopethree", "/create/labyrinthscarf", "/palaisantoia"];
  const hideFooter = hideFooterOn.includes(location.pathname) /* || isMemberSpace */ || isTrionfiRoute;

  /* !! Hide LabelFooter */
  const hideLabelFooterOn = ["/signin", "/palaisantoia"];
  const hideLabelFooter = hideLabelFooterOn.includes(location.pathname) /* || isMemberSpace */ || isTrionfiRoute;



  return (
    <div className="min-h-screen flex flex-col">
      <ScrollToTop />

      {!hideChrome && !hideHeader && (
  <Header setMenuOpen={setMenuOpen} />
)}

      {/* Main */}
      <main className="flex-grow w-full p-0">
        <Routes>

          {/* General */}
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />

          {/* Legal */}
          <Route path="/privacystatement" element={<PrivacyStatement />} />
          <Route path="/privacy" element={<PrivacyStatement />} />
          <Route path="/terms" element={<MembershipTerms />} />

          {/* Forms & access */}
       {/*    <Route path="/bookings" element={<Bookings />} /> */}
          <Route path="/signin" element={<SignIn />} />
          <Route path="/requestaccess" element={<RequestAccess />} />

          {/* Events */}
{/*           <Route path="/events" element={<EventOverview />} />
          <Route path="/events/launchevent" element={<LaunchEvent />} /> */}

          {/* Content pages */}
{/*           <Route path="/discover/wearable-stories" element={<WearableStories />} />
          <Route path="/discover/fashion" element={<FashionPage />} />
          <Route path="/journal/example" element={<JournalStory />} />
          <Route path="/howitworks" element={<HowItWorks />} />
          <Route path="/palaisantoia" element={<PalaisAntoia />} /> */}
          <Route
            path="/palaisantoia/trionfi"
            element={
              <Suspense fallback={<div className="min-h-[100dvh] bg-[#1e1616]" />}>
                <TrionfiOverview />
              </Suspense>
            }
          />
          <Route
            path="/palaisantoia/trionfi/:publicSlug"
            element={
              <Suspense fallback={<div className="min-h-[100dvh] bg-[#1e1616]" />}>
                <TrionfiCardPage />
              </Suspense>
            }
          />
          {/*             <Route path="/project" element={<Project />} />
            <Route path="/projectoverview" element={<ProjectOverview />} />
            <Route path="/faq" element={<FAQ />} />
            
            <Route path="/funding" element={<Funding />} /> */}
{/*           <Route path="/manifesto" element={<Manifesto />} /> */}

          {/* Create pages */}
{/*           <Route path="/drops" element={<Drops />} />
          <Route path="/create/labyrinth-scarf" element={<Create_LabyrinthScarf />} />
          <Route path="/create/hope-blanket" element={<Create_HopeBlanket />} /> */}

          {/* Store */}
          {/* <Route path="/category" element={<Category />} /> */}
{/*             <Route path="/productoverview" element={<ProductOverview />} />
            <Route path="/store" element={<Store />} />
            <Route path="/product/:slug" element={<ProductPage />} />
            <Route path="/gift/:slug" element={<ProductGift />} /> */}
{/*             <Route path="/giftredeem" element={<GiftRedeem />} />
            <Route path="/paylink" element={<PayLink />} />
            <Route path="/paylink2" element={<PayLink2 />} /> */}

          {/* Auth */}
          <Route path="/auth/callback" element={<AuthCallback />} />
          {/* <Route path="/members" element={<MembersHome />} /> */}


          {/* !! Members-only pages !! */}
          <Route
            element={
              <ProtectedRoute>
                <MembersLayout />
              </ProtectedRoute>
            }
          >
            {/* Account */}
            <Route path="/members" element={<MembersHome />} />
            <Route path="/settings" element={<ProfileSettings />} />
            <Route path="/readdata" element={<ReadData />} />
            <Route path="/wallet" element={<Wallet />} />
            <Route path="/wallet/story/:creationId" element={<ReadStory />} />


            {/* <Route path="/wallet" element={<Wallet />} />
            <Route path="/yourorders" element={<YourOrders />} />
            <Route path="/productstatus" element={<ProductStatus />} />
            <Route path="/readdata" element={<ReadData />} /> */}

            {/* Private Create */}
{/*              <Route path="/members/create/knitplus" element={<Create_KnitPlus />} /> */}
 {/*           <Route path="/members/create/labyrinthscarf" element={<Create_LabyrinthScarf />} />
            <Route path="/members/create/hopethree" element={<Create_HopeThree />} /> */}

            {/* Private content */}
            {/* <Route path="/inbox" element={<Inbox />} />
            <Route path="/research" element={<Research />} /> */}

            {/* Webstore */}
            {/* <Route path="/category" element={<Category />} />
            <Route path="/product" element={<ProductPage />} />
            <Route path="/productoverview" element={<ProductOverview />} /> */}






          </Route>
          {/* !! Members-only pages !! */}

        </Routes>
      </main>

      {!hideChrome && !hideFooter && <Footer />}
      {!hideChrome && !hideLabelFooter && <LabelFooter />}
      <SpeedInsights />
      <Analytics />
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppLayout />
    </Router>
  );
}

export default App;
